import './MomentOfSilence.scss';

const SILENCE_HOUR = 9;
const KYIV_TIMEZONE = 'Europe/Kyiv';

function getKyivTime() {
  const now = new Date();
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: KYIV_TIMEZONE,
    hour: 'numeric',
    minute: 'numeric',
    hour12: false,
  }).formatToParts(now);

  return {
    hours: parseInt(parts.find(p => p.type === 'hour').value, 10),
    minutes: parseInt(parts.find(p => p.type === 'minute').value, 10),
  };
}

function isSilenceTime() {
  const { hours, minutes } = getKyivTime();
  return hours === SILENCE_HOUR && minutes === 0;
}

function getMsUntilSilenceEnd() {
  const now = new Date();
  // Europe/Kyiv offset is always whole hours, so seconds/ms match UTC
  return Math.max(0, 60000 - (now.getSeconds() * 1000 + now.getMilliseconds()));
}

const initMomentOfSilence = () => {
  const node = document.getElementById('moment-of-silence');
  if (!node || !isSilenceTime()) return;

  const closeButton = node.querySelector('[data-button="close"]');
  let timer = null;

  const hide = () => {
    clearTimeout(timer);
    node.classList.remove('-visible');
  };

  node.classList.add('-visible');
  timer = setTimeout(hide, getMsUntilSilenceEnd());

  closeButton.addEventListener('click', hide);
};

initMomentOfSilence();
